import styled from 'styled-components';

const PatientInfoWrapper = styled.div`
  position: relative;
  .patient-status-indicator {
    left: -0.2em;
    position: absolute;
    transform: translateY(50%);
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    &.Validated {
      background-color: ${p => p.theme.color.successGreen};
    }
    &.NotValidated {
      background-color: ${p => p.theme.color.gold};
    }
    &.Blocked {
      background-color: ${p => p.theme.color.error};
    }
  }

  .full-name  {
    margin-left: 0.8em;
    text-align: left;
    color: ${p => p.isFinished ? p.theme.color.label : 'inherit'};
    text-decoration: none;
    & > span {
      text-transform: capitalize;
      margin-right: 0.3em;
      display: inline-block;
      &:first-of-type {
        text-transform: uppercase;
        font-weight: bold;
      }
    }
  }

  .personal-info {
    margin-left: 0.8em;
    text-align: left;
    font-size: 14px;
    color: ${p => p.theme.color.label};
    .new-patient {
      font-size: 14px;
      font-weight: 500;
      color: ${p => p.theme.color.successGreen};
    }
  }
`;


export default {
  PatientInfoWrapper,
};
